import { mean } from './format';

export const FIBRE_LOADING = 'Loading fibre…';
export const FIBRE_ERROR = 'Diet tracking couldn’t be loaded';

// Fibre from diet tracking. The target is the client's current one only (the
// API keeps no history), applied to every day. A day without an actual
// tracking is "Not logged" — never 0 g.

/** The client's current fibre target in grams, or null when none is set. */
export function fibreTargetOf(preset) {
  const g = Number(preset?.fiber);
  return Number.isFinite(g) && g > 0 ? g : null;
}

/**
 * One row per tracked day: fibre counts as logged only when the day has an
 * actual tracking, so an untracked day is "Not logged", never 0 g.
 * Rows sit in `body.data` (an array, or a single object), as useDietPlanTab reads them.
 */
export function fibreDaysOf(response) {
  const body = response?.data?.data;
  const rows = Array.isArray(body) ? body : body ? [body] : [];
  return rows
    .filter((r) => r?.date)
    .map((r) => {
      const logged = Array.isArray(r.actual_trackings) && r.actual_trackings.length > 0;
      const g = Number(r.tracked_nutrition_totals?.fiber);
      return { date: String(r.date).slice(0, 10), logged, g: logged && Number.isFinite(g) ? g : null };
    });
}

/** `fibreDays` rows → `{ [iso]: grams }` for logged days only. */
export function fibreByDay(fibreDays) {
  const out = {};
  (fibreDays || []).forEach((r) => {
    if (r.logged && r.g != null) out[r.date] = r.g;
  });
  return out;
}

/**
 * Fibre over a span.
 * - `pct`: days at or above the target ÷ days logged; null with no target or no logged day.
 */
export function fibreStats(byDay, isos, target) {
  const L = isos.filter((iso) => byDay[iso] != null).map((iso) => byDay[iso]);
  const hit = target ? L.filter((g) => g >= target).length : 0;
  return {
    n: L.length,
    hit,
    avg: mean(L),
    pct: target && L.length ? (hit / L.length) * 100 : null,
  };
}
